import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';

declare var Swal: any;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiBaseURL + '/auth/authenticate';
  private authDataKey = 'auth_data';

  constructor(private http: HttpClient, private router: Router) { }

  login(email: string, password: string): Observable<any> {
    return this.http.post(this.apiUrl, { email, password }).pipe(
      timeout(5000),
      catchError(error => {
        if (error instanceof TimeoutError) {
          return throwError(() => new Error('Servidor demorou muito para responder. Tente novamente.'));
        }
        return throwError(() => error);
      })
    );
  }

  saveAuthData(authData: { token: string, email: string, firstName: string, lastName: string, roles: string }): void {
    localStorage.setItem(this.authDataKey, JSON.stringify(authData));
  }

  getAuthData(): { token: string, email: string, firstName: string, lastName: string, roles: string } | null {
    const authData = localStorage.getItem(this.authDataKey);
    return authData ? JSON.parse(authData) : null;
  }

  getToken(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.token : null;
  }

  hasRole(role: string): boolean {
    const roles = this.getAuthData()?.roles;
    return Array.isArray(roles) && roles.includes(role);
  }

  hasRoles(requiredRoles: string[]): boolean {
    const roles = this.getAuthData()?.roles;
    return Array.isArray(roles) && requiredRoles.some(role => roles.includes(role));
  }

  getEmail(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.email : null;
  }

  getFirstName(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.firstName : null;
  }

  getLastName(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.lastName : null;
  }

  getFullName(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.firstName + ' ' + authData.lastName : null;
  }

  getDisplayName(): string | null {
    const authData = this.getFullName();
    return authData ? authData + ' - INECV' : null;
  }

  getFirtLetter(): string | null {
    const authData = this.getAuthData();
    return authData ? authData.firstName.charAt(0).toUpperCase() + authData.lastName.charAt(0).toUpperCase() : null;
  }

  logout(): void {
    localStorage.removeItem(this.authDataKey);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  showSessionExpiredAlert(): void {
    Swal.fire({
      title: 'Aviso!',
      text: 'A sua sessão expirou! Pretende terminar a sessão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      // @ts-ignore
    }).then((result) => {
      if (result.isConfirmed) {
        this.logout();
        this.router.navigate(['/login']);
      }
    });
  }
}
